import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultInfo } from './ResultInfo';
import { ResultOption } from './ResultOption';
import { ResultTitle } from './ResultTitle';
import {
    SelectAction,
    type ActionFunction,
    type ResultsProps,
} from './ResultTypes';

export const commandResultsAction: ActionFunction = ({ metaData, result }) => {
    trackResultClick(result, metaData.tracking);
    window.location.href = result.url;
    return SelectAction.CLOSE;
};

export function CommandResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            {resultGroup.results.map((result) => (
                <ResultOption
                    className="my-4"
                    linkClass="block"
                    key={`${result.resultType}-${result.order}-${resultId}`}
                    result={result}
                >
                    <ResultTitle result={result} />
                    <ResultInfo result={result} />
                </ResultOption>
            ))}
        </ResultGroup>
    );
}
